export const Share = () => {
  const shareUrl = "https://MivehKani.ir";
  const clipboard = navigator.clipboard;
  clipboard
    .writeText(shareUrl)
    .then(() => alert("لینک با موفقیت کپی شد"))
    .catch(() => alert("مشکل در کپی لینک"));
};
